module.exports = "https://static.wmbcdn.com/uniweb/images/9b64f04fd328805ec40da91fdc6cce57.svg";